import React from "react";

const TemplateContext = React.createContext();

export default TemplateContext;
